import { render, staticRenderFns } from "./ShowNotesEvents.vue?vue&type=template&id=2a473692&scoped=true"
import script from "./ShowNotesEvents.vue?vue&type=script&lang=js"
export * from "./ShowNotesEvents.vue?vue&type=script&lang=js"
import style0 from "./ShowNotesEvents.vue?vue&type=style&index=0&id=2a473692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a473692",
  null
  
)

export default component.exports